// extracted by mini-css-extract-plugin
module.exports = {"wrapper-link":"_1HBZn","tooltip":"Gruks","tooltiptext":"S4ADD"};